import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
// src/artwork.ts
var hasManufactureReadyArtwork = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.manufacturingReadyDocumentUrl);
};
var hasDocumentReferenceComplete = lineItem => {
  var _a;
  return Boolean(((_a = lineItem.custom) == null ? void 0 : _a.fields.mcpDocumentsSource) && lineItem.custom.fields.userUploadComplete !== false);
};
var hasAlternativelyUploaded = lineItem => {
  var _a, _b;
  return Boolean(((_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.userUploadsUrl) == null ? void 0 : _b[0]) && lineItem.custom.fields.userUploadComplete);
};
var artworkRequired = lineItem => {
  var _a, _b, _c;
  return Boolean(((_c = (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.artworkRequired) == null ? void 0 : _b.trim()) == null ? void 0 : _c.toLowerCase()) === "yes");
};
var isReviewedArtworkUploaded = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.artworkUploadURL);
};
var isArtworkDelivered = lineItem => Boolean(hasAlternativelyUploaded(lineItem) || hasDocumentReferenceComplete(lineItem) || hasManufactureReadyArtwork(lineItem) || isReviewedArtworkUploaded(lineItem));
var needsArtwork = order => !order.lineItems.every(lineItem => Boolean(hasAlternativelyUploaded(lineItem) || hasDocumentReferenceComplete(lineItem) || hasManufactureReadyArtwork(lineItem) || !artworkRequired(lineItem)));
var isReviewGroupLead = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.isReviewGroupLead);
};
var hasReviewGroup = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup);
};
var isImage = contentType => contentType.toLowerCase().match(/\.(gif|jpg|jpeg|png|tiff)+$/g);
var isAlternativeUploadsUrl = lineItem => {
  var _a;
  if ((_a = lineItem.custom) == null ? void 0 : _a.fields.userUploadsUrl) {
    const url = lineItem.custom.fields.userUploadsUrl;
    return url ? url.map(string => string.split("::")).filter(subStr => isImage(subStr[1]) !== null).flatMap(subStr => subStr)[2] : null;
  }
  return null;
};
export { hasManufactureReadyArtwork, hasDocumentReferenceComplete, hasAlternativelyUploaded, artworkRequired, isReviewedArtworkUploaded, isArtworkDelivered, needsArtwork, isReviewGroupLead, hasReviewGroup, isImage, isAlternativeUploadsUrl };